import React, { useState, useEffect } from 'react';
import { SERVER_URL } from '../../../Config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const Table = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [entitiesPerPage, setEntitiesPerPage] = useState(5);
  const [tableEntries, setTableEntries] = useState([]);
  const [userData, setuserData] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [UserAccounts, setUserAccounts] = useState([]);
  const navigate = useNavigate()

  const getUserdatas = async () => {
    try {
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        navigate('/Login');
        return;
      }

      const decodedToken = jwtDecode(token);
      const res = await axios.get(`${SERVER_URL}/api/getUserdatas?AppID=${decodedToken.AppID}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {

        setuserData(res.data.User);
        setUserAccounts(res.data.accounts)
        const choosedAccount = sessionStorage.getItem('selectedAccount');

        if (!choosedAccount) {
          setSelectedAccount(res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null);
          sessionStorage.setItem('selectedAccount', res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null)
        } else {
          setSelectedAccount(sessionStorage.getItem('selectedAccount'))
        }
      } else {
        setuserData([]);
        setSelectedAccount(null);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);

      if (error.response?.status === 403) {
        toast.error('Session expired');
        navigate('/Login');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem('_token');
    if (token) {
      getUserdatas();
    }
  }, [sessionStorage.getItem('_token')]);

  const [debitedAmount, setDebitedAmount] = useState(0);
  const [creditedAmount, setUserCreditedAmount] = useState(0);

  const getUserTransactions = async (app_id) => {
    try {
      const res = await axios.get(`${SERVER_URL}/api/transaction?app_id=${app_id}`);

      if (res.data.status) {
        const transactions = res.data.transactions;
        setTableEntries(transactions);

        let totalDebited = 0;
        let totalCredited = 0;

        transactions.forEach((txn) => {
          if (txn.from_id === app_id) {
            totalDebited += Number(txn.amount);
          }
          if (txn.to_id === app_id) {
            totalCredited += Number(txn.amount);
          }
        });

        setDebitedAmount(totalDebited);
        setUserCreditedAmount(totalCredited);
      } else {
        console.error("Error fetching transactions:", res.data.message);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    if (userData?.app_id) {
      getUserTransactions(userData.app_id);
    }
  }, [userData]);

  const indexOfLastEntity = currentPage * entitiesPerPage;
  const indexOfFirstEntity = indexOfLastEntity - entitiesPerPage;
  let currentEntities = tableEntries?.slice(indexOfFirstEntity, indexOfLastEntity);
  const emptyRowCount = entitiesPerPage - currentEntities?.length;

  const handlePrevClick = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextClick = () => {
    if (currentEntities.length === entitiesPerPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleDropdownChange = (e) => {
    setEntitiesPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const ViewHash = (hash) => {
    window.open(`https://snowtrace.io/tx/${hash}`, "_blank");
  };

  return (
    <div className=' w-[100%] mx-auto '>
      <div className="mt-5">
        <div className="bg-[#1D1D1C] rounded-3xl py-5 w-full mx-auto flex justify-between items-center ">
          <div className="w-[100%] mx-auto">
            <div className="font-san px-3">
              <p className="text-end text-xs mb-2">
                Show no of entity
                <select
                  className="ml-2 outline-none rounded-md bg-transparent border-[1px]"
                  onChange={handleDropdownChange}
                  value={entitiesPerPage}
                >
                  <option className="text-black" value="4">
                    5
                  </option>
                  <option className="text-black" value="5">
                    10
                  </option>
                  <option className="text-black" value="10">
                    20
                  </option>
                </select>
              </p>
              <div className=" overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full text-center">
                    <thead>
                      <tr className="border-b border-white/40">
                        <th className="py-3 px-5 md:px-0 whitespace-nowrap">
                          Trasaction Hash
                        </th>
                        <th className="py-3 px-5 md:px-0 whitespace-nowrap">
                          Tokens
                        </th>
                        <th className="py-3 px-5 md:px-0 whitespace-nowrap">
                          Amount
                        </th>
                        <th className="py-3 px-5 md:px-0 whitespace-nowrap">
                          Date of transaction
                        </th>
                        <th className="py-3 px-5 md:px-0 whitespace-nowrap">
                          Trasaction type
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {currentEntities.map((entity, index) => (
                        <tr
                          key={index}
                          className="h-14 w-full text-xs md:text-sm cursor-pointer rounded-xl"
                        >
                          <td
                            className={` px-5 lg:px-0 whitespace-nowrap`} onClick={() => ViewHash(entity.trn_hash)}
                          >
                            {entity.trn_hash}
                          </td>
                          <td
                            className={`px-5 lg:px-0 whitespace-nowrap`}
                          >
                            {entity.token_name}
                          </td>
                          <td
                            className={`${entity.tranType === 'debit' ? 'text-red-600' : 'text-green-600'} px-5 lg:px-0 whitespace-nowrap`}
                          >
                            {Number(entity.amount).toFixed(3)}
                          </td>
                          <td
                            className={` px-5 lg:px-0 whitespace-nowrap`}
                          >
                            {entity.formatted_created_at}
                          </td>
                          <td
                            className={`${entity.tranType === 'debit' ? 'text-red-600' : 'text-green-600'} px-5 lg:px-0 whitespace-nowrap capitalize`}
                          >
                            {entity.tranType}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="mt-2 flex justify-end text-xs px-10">
                <div className="flex gap-3">
                  <button
                    className={`bg-white/20  rounded-md px-2 py-1  `}
                    onClick={handlePrevClick}
                    disabled={currentPage === 1}
                  >
                    <i class="fa-solid fa-arrow-left"></i>
                  </button>
                  <button
                    className={` bg-white/20 rounded-md px-2 py-1  `}
                    onClick={handleNextClick}
                    disabled={currentEntities.length < entitiesPerPage}
                  >
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Table